// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"StyledTitle\"] {\n  position: absolute;\n  pointer-events: none;\n  z-index: 170;\n  padding: 3px 7px;\n  border-radius: 3px;\n  color: #7a7a7a;\n  background: #fff;\n  box-shadow: 0 5px 10px 0 rgba(0,0,0,0.15);\n  font-size: 13px;\n  -webkit-animation: fade-in 150ms ease-in-out;\n          animation: fade-in 150ms ease-in-out;\n}\n\n.fullscreen [name=\"StyledTitle\"] {\n  z-index: 10000000000;\n}", ""]);
// Exports
module.exports = exports;
